/**
 * Created by swandelow on 17/08/17.
 */
/*
* Disables an element (e.g: button) to prevent multiple clicking while an async task is resolved.
*
* The function that performs such async task should return a Promise!.
*
* */
angular.module('CarsSaraBo').directive('clickAndWait', function () {
    return {
        restrict: 'A',
        scope: {
            clickAndWait: '&'
        },
        link: function (scope, element) {
            element.bind('click', function () {
                element.prop('disabled', true);
                scope.$apply(function () {
                    scope.clickAndWait().finally(function () {
                        element.prop('disabled', false);
                    });
                });
            });
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./public/app/commons/click-and-wait/click-and-wait.directive.js
// module id = 929
// module chunks = 3